export const selectError = (state) => state.auth.error
export const selectCurrentUser = (state) => state.auth.currentUser
export const selectStatus = (state) => state.auth.status
